// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bHVT","placeholdersHeader":"styles_placeholdersHeader__3pGud","editorStyle":"styles_editorStyle__2Rghs","placeholdersBox":"styles_placeholdersBox__1Dj5t"};